/*
* 设备数据处理
* */
import {onMounted, reactive, ref} from "vue";
import devStore from "@/stores/devStore"

export default function () {
    console.log("project")
    // 更改路由名称
    let devInfo = devStore(); // 设备缓存
    const size = "20";
    // 设备选中后的数组
    let allDev = devInfo.allDev;
    // 设备选择的总数组
    let modularDev = reactive({
        // 主设备
        primaryOptions: [
            {label: "摄像头7.0", value: '7'},
            {label: "摄像头8.0", value: '8'},
            {label: "红绿灯", value: '26'},
        ],
        // 模块化设备
        modularOptions: [
            {label: "引导屏", value: '25'},
            {label: "AI盒子(车牌+AOA)", value: '31'},
            {label: "AI盒子(纯车牌识别)", value: '32'},
            {label: "AI盒子(纯AOA运算)", value: '33'},
            {label: "星闪AOA盒子", value: '35'},
            {label: "AI盒子(地锁网关)", value: '71'},
        ]
    })

    // 控制地图展示
    let map = ref(false)
    let parkMap = ref(false)
    // 打开蜂寻地图
    let beefindMap = function () {
        map.value = true;
    }
    let beefindParkMap = function () {
        parkMap.value = true;
    }

    // 获取设备列表
    onMounted(() => {
        devInfo.getDevStoreList()
    });

    // 筛选框默认不展开
    let activeKey = ref(['0'])
    let devKey = ref(['0'])

    // 设备类型图片地址
    const devUrl = 'https://www.beefindtech.com/webProject/mapDataEdit/images/';
    // 获取设备类型图片
    let devImage = (type) => {
        let image = "";
        switch (true) {
            case type === '7' || type === '8':
                image = devUrl + 'devType7.png';
                break;
            case  type === '26':
                image = devUrl + 'devType26.png';
                break;
            case  type === '31':
                image = devUrl + 'devType31.png';
                break;
            case  type === '32':
                image = devUrl + 'devType32.png';
                break;
            case  type === '33':
                image = devUrl + 'devType33.png';
                break;
            case  type === '35':
                image = devUrl + 'devType35.png';
                break;
            case  type === '25':
                image = devUrl + 'devType25.png';
                break;
            case  type === '71':
                image = devUrl + 'devType71.png';
                break;
        }
        return image;
    }
    // 获取设备标签图片
    let devTagUrl = (type) => {
        return devUrl + type + '.png';
    }
    // 输入框键盘事件
    let handleKey = function (e) {
        // 获取按下的键的ASCII码
        const keyCode = e.keyCode || e.which;
        // 检查是否按下了特定的键，例如回车键
        if (keyCode === 13) {
            devInfo.devChange()
        }
    }

    return {
        allDev,
        modularDev,
        size,
        activeKey,
        beefindMap,
        devInfo,
        devKey,
        devImage,
        devTagUrl,
        handleKey,
        map,
        parkMap,
        beefindParkMap
    }
}
